// extracted by mini-css-extract-plugin
module.exports = {"shadow":"menu-bar_shadow__2nq7f","textShadow":"menu-bar_textShadow__3MYA0","menuBar":"menu-bar_menuBar__23izn"};